export default __webpack_public_path__ + "static/itfirms-3750f14bf8855905d6f0b1694e0725d5.png";